import React from 'react';
import PayrollPage from '../pages/payslip/index';
import ProtectedRoute from './protected';

export const PayslipRoutes = [
  <ProtectedRoute exact path='/payslip' component={PayrollPage} />,
]
